import { createContext } from 'react';

type AgentContextType = {
  fullName?: string;
  identity?: string,
  phoneNumber?: string,
}

const defaultValue = {
  fullName: undefined,
  identity: undefined,
  phoneNumber: undefined,
};

export const AgentContext = createContext<AgentContextType>(defaultValue);
